<template>
  <main>
    <div class="side-page-container background-opacity" style="padding-inline: 20dvw; padding-block: 20dvh; border-radius: 25px">
      <div class="text-center orbitron-font">
        <h2 class="d-flex justify-content-center align-items-center">
          <span class="orbitron-font display-1 fw-bold text-white">4</span>
          <i style="color: crimson" class="fa-solid fa-circle-exclamation fa-2x"></i>
          <span class="orbitron-font display-1 fw-bold mirror-text text-white">4</span>
        </h2>
        <h2 class="text-title">Oops! Are you lost?</h2>
        <p class="mb-5 text-white">The page you are trying to access does not exist.</p>
        <a class="btn btn-squared hover-simple hover-background tertiary rounded-pill px-5" href="/">Back to Home</a>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'NotFound',
};
</script>
